interface SectionHeadingProps {
	title: string;
	description?: string;
}

export const SectionHeading = ({ title, description }: SectionHeadingProps) => (
	<div className="flex flex-col gap-4">
		<span className="size-18 font-semibold text-black">{title}</span>
		{description && (
			<span className="size-14-light text-grey">{description}</span>
		)}
	</div>
);
